import { Factory, QuickFactory } from '@infodata-group/inf-commons';
import { VehicleExpense } from '../model/vehicle-expense';
import { VehicleExpenseDto } from '../interface/vehicle-expense.dto';

export class VehicleExpenseFactory
  extends QuickFactory
  implements Factory<VehicleExpense>
{
  private readonly vehicleId: string;

  constructor(vehicleId: string) {
    super();
    this.vehicleId = vehicleId;
  }

  build(o: VehicleExpenseDto): VehicleExpense {
    const vehicleExpense: VehicleExpense = new VehicleExpense();
    this.generateProperty(vehicleExpense, o);

    return vehicleExpense;
  }

  getApi(): string {
    return `administration/fleet/vehicles/${this.vehicleId}/expenses/`;
  }
}
